export default __webpack_public_path__ + "static/media/whatwedo3.a87b1b35.jpg";